import Vue from 'vue'
import './registerServiceWorker'
import './validation'
import './assets/style.scss'
import App from './App.vue'
import router from './router'
import Snotify, { SnotifyPosition } from 'vue-snotify'
import store from './store'
import VueProgressBar from 'vue-progressbar'
import { VueReCaptcha } from 'vue-recaptcha-v3'
Vue.use(VueReCaptcha, { siteKey: '6LfSjrIZAAAAADhZ6UA5P5JXkU4QU2q5gkYdrMSH' })

Vue.use(Snotify, {
  toast: {
    position: SnotifyPosition.centerTop,
    timeout: 5000,
  },
})

Vue.use(VueProgressBar, {
  color: 'rgba(90, 218, 94, 0.8)',
  failedColor: 'rgba(251, 0, 0, 0.77)',
  thickness: '4px',
  transition: {
    opacity: '1s',
    speed: '0.4s',
    termination: 100,
  },
  autoRevert: true,
  inverse: false,
})

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
